import { Pencil } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { OrderModel } from '@/types/model/Order'
import { useState } from 'react'
import { AddressSelectDialog } from './AddressSelectDialog'

interface OrderShippingAddressProps {
    order: OrderModel.Order
    actions: {
        updateAddress: (addressId: string) => void
    }
    isEditable?: boolean
}

export const OrderShippingAddress = ({ order, actions, isEditable = true }: OrderShippingAddressProps) => {
    const [isSelectOpen, setIsSelectOpen] = useState(false)

    return (
        <Card>
            <CardHeader className="flex-row items-center justify-between gap-2 space-y-0">
                <CardTitle>Delivery address</CardTitle>
                {isEditable && (
                    <Button variant="ghost" size="icon" aria-label="Change delivery address" onClick={() => setIsSelectOpen(true)}>
                        <Pencil />
                    </Button>
                )}
            </CardHeader>
            <CardContent className="space-y-1 text-sm">
                <p className="font-medium capitalize text-ink">
                    {order.delivery_info?.name || 'No recipient name'}
                </p>
                {order.delivery_info?.phone && (
                    <p className="tabular-nums text-text-2">{order.delivery_info?.phone}</p>
                )}
                <p className="whitespace-pre-line text-text-2">
                    {order.delivery_info?.address || 'No address provided'}
                </p>
            </CardContent>

            <AddressSelectDialog
                open={isSelectOpen}
                onOpenChange={setIsSelectOpen}
                userId={order.customer_id || undefined}
                currentAddressId={order.address_id}
                onSelect={actions.updateAddress}
            />
        </Card>
    )
}
